<template>
  <v-app>
    <v-content>
      <v-container class="fill-height" style="justify-content: center" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="7" lg="6" xl="6">
            <v-card class="mx-auto" max-width="600">
              <v-row justify="center">
                <v-img
                  align="center"
                  justify="center"
                  class="mt-12 mb-6"
                  aspect-ratio="8"
                  :transition="false"
                  contain
                  :src="
                    require(`@/assets/${this.$store.getters.getLogo.path}/logo.png`)
                  "
                />
              </v-row>
              <v-row justify="center" v-if="resetForm.error">
                <v-card class="elevation-0">
                  <v-card-text style="color: red">{{
                    $t(
                      "general.resetPasswordRequest.theEmailYouEnteredWasNotFound"
                    )
                  }}</v-card-text>
                </v-card>
              </v-row>
              <v-row
                justify="center"
                v-if="resetForm.success"
                class="pl-0 pr-0 ml-0 mr-0"
              >
                <v-card class="elevation-0">
                  <v-card-title class="subtitle-1" style="text-align: center">{{
                    getResetSuccessText
                  }}</v-card-title>
                </v-card>
              </v-row>
              <v-form
                @submit.prevent="resetPassword"
                ref="form"
                v-model="valid"
                lazy-validation
              >
                <v-row v-if="!resetForm.success">
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                    <v-text-field
                      class="ml-10 mr-10"
                      color="primary"
                      :label="$t('general.resetPasswordRequest.enterEmail')"
                      name="login"
                      :rules="emailRule"
                      type="text"
                      v-model="resetForm.email"
                      required
                    />
                  </v-col>
                </v-row>
                <v-card-actions class="mx-auto">
                  <v-row dense>
                    <v-col
                      cols="12"
                      sm="12"
                      md="6"
                      lg="6"
                      xl="6"
                      class="
                        d-flex
                        justify-center
                        d-sm-flex
                        justify-sm-center
                        d-md-flex
                        justify-md-center
                      "
                    >
                      <v-btn @click="login()" color="primary" text>{{
                        $t("general.resetPasswordRequest.backToLogin")
                      }}</v-btn>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="12"
                      md="6"
                      lg="6"
                      xl="6"
                      class="
                        d-flex
                        justify-center
                        d-sm-flex
                        justify-sm-center
                        d-md-flex
                        justify-md-center
                      "
                    >
                      <v-btn
                        v-if="!resetForm.success"
                        @click="resetPassword()"
                        color="primary"
                        class="float-md-right float-lg-right float-xl-right"
                        text
                        >{{
                          $t("general.resetPasswordRequest.resetPassword")
                        }}</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { AUTH_REQUEST, AUTH_RESET } from "@/store/actions/auth.js";
export default {
  name: "login",
  data() {
    return {
      resetForm: {
        error: false,
        success: false,
        active: false,
        email: "",
      },
      emailRule: [],
      valid: true,
    };
  },
  computed: {
    getResetSuccessText() {
      return this.$t(
        "general.resetPasswordRequest.anEmailWasSentToWithInstructionsToRecoverYourPassword",
        { email: this.resetForm.email }
      );
    },
  },
  created() {
    this.setInitialData();
  },
  methods: {
    setInitialData() {
      this.emailRule = [
        (v) => !!v || this.$t("general.resetPasswordRequest.eMailIsRequired"),
        (v) =>
          /.+@.+\..+/.test(v) ||
          this.$t("general.resetPasswordRequest.eMailMustBeValid"),
      ];
    },
    login: function () {
      this.$router.push({
        name: "login",
      });
    },
    resetPassword: function () {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch(AUTH_RESET, { email: this.resetForm.email })
          .then((resp) => {
            if (resp === "success") {
              this.resetForm.success = true;
              this.resetForm.error = false;
            } else {
              this.resetForm.success = false;
              this.resetForm.error = true;
            }
          });
      }
    },
  },
};
</script>
<style>
.v-card__title {
  word-break: keep-all !important;
}
.sentinel-logo--style {
  height: 81px;
  max-width: 120px;
}
</style>
